import { Component } from '@angular/core';

@Component({
    selector: 'app-page-forbidden',
    templateUrl: './page-forbidden.component.html',
    styleUrls: ['./page-forbidden.component.scss'],
})
export class PageForbiddenComponent {
    constructor() {}
}
